import ReportTextureComposition from './ReportTextureComposition';
export default ReportTextureComposition;
